export default "__VITE_ASSET__Caxx60Gx__"